import { Fragment } from "react";

import SubNavigation from "../../components/Header/SubNavigation";
import { Section } from "design-react-kit";
import Footer from "../../components/Footer";
import AuthModuleVerificationEconTable from "../../components/Tables/AuthModuleVerificationEconTable";

const AuthModuleFlowEconNotifications = () => {
  return (
    <Fragment>
      <SubNavigation page="authModuleNotifs" />
      <Section>
        <AuthModuleVerificationEconTable
          columns={[
            {
              name: "Data di acquisizione",
              type: "date",
              sortable: false,
              value: "createdOn",
            },
            {
              name: "Notifica",
              type: "string",
              sortable: true,
              value: "subject",
            },
            {
              name: "Notifica analogica: tipo notifica",
              type: "string",
              sortable: false,
              value: "analogicalType",
            },
            {
              name: "Costo componente piattaforma",
              type: "number",
              sortable: false,
              value: "totalPlatformCost",
            },
            {
              name: "Costo Totale Notifiche Analogiche",
              type: "number",
              sortable: false,
              value: "totalAnalogicalCost",
            },
            {
              name: "Costo Notifica",
              type: "string",
              sortable: false,
              value: "analogicalDeliveryType",
            },
            {
              name: "",
              type: null,
              sortable: false,
              value: "",
            },
          ]}
        />
      </Section>
      <Footer />
    </Fragment>
  );
};

export default AuthModuleFlowEconNotifications;
